import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { type FC, memo } from 'react';

const BareCenterIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 16 16' {...props}>
    <path
      d='M0 11.002V5.005l4 2.999-4 2.998zm1.96-6.536a7.046 7.046 0 012.507-2.499l.6.8a6.024 6.024 0 00-2.3 2.299l-.806-.6H1.96zm0 7.069l.8-.6a6.033 6.033 0 002.3 2.3l-.6.799a7.046 7.046 0 01-2.507-2.499h.007zm6.039.46l3 4.005H5l3-4.005zm3-11.995l-3 4.005L5 .007 11 0zm-.068 13.23a5.956 5.956 0 002.3-2.299l.8.6a7.064 7.064 0 01-2.5 2.505l-.6-.8v-.006zm0-10.47l.6-.799a7.04 7.04 0 012.5 2.505l-.8.6a5.946 5.946 0 00-2.3-2.3v-.005zM12 8.005l4-3v5.998l-4-2.998z'
      fill='currentColor'
      className='svgicon__hover-hide'
    />
    <path
      d='M1 11.002V5.005l4 2.999-4 2.998zm.96-6.536a7.047 7.047 0 012.507-2.499l.6.8a6.024 6.024 0 00-2.3 2.299l-.807-.6zm0 7.069l.8-.6a6.033 6.033 0 002.3 2.3l-.6.799a7.046 7.046 0 01-2.507-2.499h.007zm6.039-.54L11 15H5l2.999-4.005zm3-9.995L8 5.005 5 1.007 10.999 1zm-.068 12.23a5.956 5.956 0 002.3-2.299l.8.6a7.065 7.065 0 01-2.5 2.505l-.6-.8v-.006zm0-10.47l.6-.799a7.04 7.04 0 012.5 2.505l-.8.6a5.947 5.947 0 00-2.3-2.3v-.005zM11 8.005l4-3v5.998l-4-2.998z'
      fill='currentColor'
      className='svgicon__hover-show'
    />
  </SvgWrapper>
);
export const CenterIcon = memo(BareCenterIcon);
